<template>
    <b-modal
      size="lg"
      :hideFooter="true"
      id="trainingApproveModal"
      @show="onShow"
    >
      <template slot="modal-title">
        <h5>
          <em class="far fa-file-alt"></em> Подтверждение занятия в группе
        </h5>
      </template>
      <template slot="default">
          <div v-if="rolesData.length > 0">
              <h6>
                  Роли, присутствующие не во всех этапах
              </h6>
              <div class="rolesTable" ref="gridDiv">
                <ag-grid-vue
                    style="width: 100%; height: 100%;"
                    class="ag-theme-material ag-grid-vue-progress"
                    rowHeight="78"
                    :gridOptions="gridOptions"
                    :columnDefs="rolesColumns"
                    :rowData="rolesData"
                    :suppressPaginationPanel="true"
                    :context="context"
                    @grid-ready="onRolesGridReady"
                    @gridSizeChanged="onRolesGridSizeChanged"
                >
                </ag-grid-vue>
              </div>
          </div>
          <div v-if="studentsData.length > 0" class="mt-3">
              <h6>
                  Ученики без роли
              </h6>
              <div class="rolesTable" ref="gridDiv">
                <ag-grid-vue
                    style="width: 100%; height: 100%;"
                    class="ag-theme-material ag-grid-vue-progress"
                    rowHeight="78"
                    :gridOptions="gridOptions"
                    :columnDefs="studentsColumns"
                    :rowData="studentsData"
                    :suppressPaginationPanel="true"
                    :context="context"
                    @grid-ready="onStudentsGridReady"
                    @gridSizeChanged="onStudentsGridSizeChanged"
                >
                </ag-grid-vue>
              </div>
          </div>
          <div v-if="studentsData.length === 0 && rolesData.length === 0" class="settingsCorrect">
            <p>
              Настройки корректны!
            </p>
          </div>
          <div v-if="getGroupTrainingMode === 1">
            <p class="marksTitle">
              Максимальное количество ошибок:
            </p>
            <div class="row">
              <span class="ml-4 p-2">
                5 - <input v-model="marks['5']" class="markInput" type="number" min="0"> <br>
                <span class="markInput__markError"
                  v-show="marks !== null ? marks['5'] < 0 : false"
                >
                  Количество ошибок задано неверно
                </span>
                <span class="markInput__markError"
                  v-show="marks !== null ? marks['5'] === '' : false"
                >
                  Укажите количество ошибок
                </span>
              </span>
            </div>
            <div class="row">
              <span class="ml-4 p-2">
                4 - <input v-model="marks['4']" class="markInput" type="number" min="0"> <br>
                <span class="markInput__markError"
                  v-show="(marks !== null && marks['4'] !== '')
                  ? (marks['4'] < 0 || Number(marks['4']) <= Number(marks['5'])) : false"
                >
                  Количество ошибок задано неверно
                </span>
                <span class="markInput__markError"
                  v-show="marks !== null ? marks['4'] === '' : false"
                >
                  Укажите количество ошибок
                </span>
              </span>
            </div>
            <div class="row">
              <span class="ml-4 p-2">
                3 - <input v-model="marks['3']" class="markInput" type="number" min="0"> <br>
                <span class="markInput__markError"
                  v-show="(marks !== null && marks['3'] !== '')
                  ? (marks['3'] < 0 || Number(marks['3']) <= Number(marks['4'])) : false"
                >
                  Количество ошибок задано неверно
                </span>
                <span class="markInput__markError"
                  v-show="marks !== null ? marks['3'] === '' : false"
                >
                  Укажите количество ошибок
                </span>
              </span>
            </div>
          </div>
          <div class="approveButtons mt-3">
            <b-button
              :disabled="Number(getGroupTrainingMode) === 1 &&
                (studentsData.length > 0 ||
                !areSettingsOk)"
              @click="startTraining"
              variant="primary" class="mr-3"
            >
              Подтвердить
            </b-button>
            <b-button @click="closeModal" variant="outline-primary">
              Отмена
            </b-button>
          </div>
      </template>
    </b-modal>
</template>

<script>

import { AgGridVue } from 'ag-grid-vue'

import { mapActions, mapGetters } from 'vuex'

import AG_GRID_LOCALE_RU from '@/config/locale.ru'

function indexFormatter(param) {
  return param.node.rowIndex + 1
}

export default {
  name: 'TrainingApproveModal',
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      marks: {
        5: 0,
        4: 0,
        3: 0
      },
      rolesColumns: [
        {
          headerName: '№',
          field: 'surname',
          headerClass: 'ag-grid-table-header',
          valueFormatter: indexFormatter,
          width: 100
        },
        {
          headerName: 'Роль',
          field: 'role',
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Этапы с ролью',
          field: 'withRole',
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Этапы без роли',
          field: 'withoutRole',
          headerClass: 'ag-grid-table-header'
        }
      ],
      studentsColumns: [
        {
          headerName: '№',
          field: 'surname',
          headerClass: 'ag-grid-table-header',
          valueFormatter: indexFormatter,
          width: 100
        },
        {
          headerName: 'Ф.И.О.',
          field: 'name',
          headerClass: 'ag-grid-table-header'
        }
      ],
      rolesData: [],
      studentsData: [],
      rolesGridApi: null,
      studentsGridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: false
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null
    }
  },
  computed: {
    ...mapGetters({
      groupSettings: 'educationStudentsManagement/getGroupTrainingSettings',
      groupStudents: 'educationStudentsManagement/getGroupTrainingStudents',
      getGroupTrainingMode: 'educationStudentsManagement/getGroupTrainingMode',
      trainingCourse: 'training/getTrainingCourse'
    }),
    areSettingsOk() {
      return (this.marks != null && (
        Number(this.marks['5']) >= 0
        && this.marks['4'] !== '' && Number(this.marks['4']) >= 0 && Number(this.marks['4']) > Number(this.marks['5'])
        && this.marks['3'] !== '' && Number(this.marks['3']) >= 0 && Number(this.marks['3']) > Number(this.marks['4'])
      ))
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'socket/sendMessage'
    }),
    onShow() {
      const rolesSet = new Set()
      this.groupStudents.forEach((st) => {
        if (st.role !== null) {
          rolesSet.add(st.role)
        }
      })

      const notAllStepsRoles = []

      rolesSet.forEach((r) => {
        const roleInfo = {
          role: r,
          withRole: [],
          withoutRole: []
        }

        this.trainingCourse.stages.filter((st) => this.groupSettings.stages.includes(st.name))
          .forEach((st) => {
            const rolesInStage = st.rolesOnPanel.map((rnp) => rnp.role)
            if (!rolesInStage.includes(r)) {
              roleInfo.withoutRole.push(st.name)
            } else {
              roleInfo.withRole.push(st.name)
            }
          })

        if (roleInfo.withoutRole.length > 0) {
          notAllStepsRoles.push(roleInfo)
        }
      })

      this.rolesData = notAllStepsRoles

      this.studentsData = this.groupStudents.filter((st) => st.role === null)
      Object.entries(this.marks).forEach((m) => {
        this.marks[m[0]] = 0
        this.trainingCourse.stages.forEach((st) => {
          if (this.groupSettings.stages.includes(st.name)) {
            this.marks[m[0]] += st.marks[m[0]]
          }
        })
      })
    },
    closeModal() {
      this.$bvModal.hide('trainingApproveModal')
    },
    onRolesGridReady(params) {
      this.rolesGridApi = params.api
      this.rolesColumnApi = params.columnApi
      this.rolesGridApi.sizeColumnsToFit()
    },
    onRolesGridSizeChanged() {
      this.rolesGridApi.sizeColumnsToFit()
    },
    onStudentsGridReady(params) {
      this.studentsGridApi = params.api
      this.studentsColumnApi = params.columnApi
      this.studentsGridApi.sizeColumnsToFit()
    },
    onStudentsGridSizeChanged() {
      this.studentsGridApi.sizeColumnsToFit()
    },
    startTraining() {
      const { trainingId } = this.$route.params
      this.sendMessage({
        action: 'startTraining',
        data: {
          type: this.getGroupTrainingMode,
          settings: {
            ...this.groupSettings,
            simulatorId: trainingId,
            allRoles: this.getAllRoles(),
            marksMap: this.marks
          }
        }
      }).then(() => {
        setTimeout(() => {
          this.$router.push(`../${trainingId}`)
        }, 300)
      })
    },
    getAllRoles() {
      const rolesDict = {}
      this.groupStudents.forEach((st) => {
        if (!rolesDict[st.group]) {
          rolesDict[st.group] = [st.role]
        } else if (!rolesDict[st.group].includes(st.role)) {
          rolesDict[st.group].push(st.role)
        }
      })

      return rolesDict
    }
  }
}
</script>

<style lang="scss" scoped>

.rolesTable {
  height: calc(100vh - 600px);
  border: 1px solid #0078c1;
}

.approveButtons {
  display: flex;
  justify-content: center;

  button {
    width: 200px;
  }
}

.settingsCorrect {
  text-align: center;
  padding: 28px 20px;
  color: #0078c1;
  font-size: 2em;
}

.marksTitle {
  font-size: 1.3em;
  font-weight: 600;
}

.markInput {
  width: 60px;

  &__markError {
    color: red;
    font-size: 0.8em;
  }
}

</style>
